import React from 'react'
import "./SubStyle.css"

const Acc_Endof = () => {
  return (
     <section className="OurServices">
     <h1 className="OurServices-title">End of Year Accounts</h1>
      <p className="OurServices-pera">Ensure your annual accounts are prepared accurately and submitted on time. We provide clear, compliant financial statements that help you understand your business performance and meet all reporting requirements with confidence.</p>
         <div className="btn-container">
        <button className="OurServices-btn">
       <a>Let's get started</a>
      </button>
     </div>
    </section>
  )
}

export default Acc_Endof
